export const itemLevelSectionsOrder = [
  "customerRTO",
  "damagedProducts",
  "wrongItemsDelivered",
  "partialItemsMissing",
];

export const crateLevelSectionsOrder = [
  "itemsReturned",
  "itemsNotReturned",
  "itemsToBeReturned",
];

export const sectionsOrder = [
  "ITEMS_itemsReturned",
  "ITEMS_itemsNotReturned",
  "ITEMS_itemsToBeReturned",
  "CRATES_itemsReturned",
  "CRATES_itemsNotReturned",
  "CRATES_itemsToBeReturned",
];

export const PRODUCT_CARD_HEIGHT = 120;
